import { NavigationHistoryBar } from "@circle-react-shared/uikit/HeaderV3/NavigationHistoryBar";
import type { MainAppContentProps } from "./index";
import { MainAppContent } from "./index";

export const ElectronAppWrapper = (props: MainAppContentProps) => (
  <div className="flex h-screen w-full flex-col">
    <NavigationHistoryBar />
    <div className="flex flex-1 overflow-hidden">
      <MainAppContent {...props} />
    </div>
  </div>
);
